import {configFields} from './config-fields';
import {flexLayout1} from './config-layout1';
import {flexLayout2} from './config-layout2';

export const formConfig = {
    fields: configFields,
    layout: 'layout2',
    layouts: [
        flexLayout1, flexLayout2
    ]
};
